import _ from 'lodash';

function mergeValues(object, source) {
  const keys = _.keys(object);
  return _.merge(object, _(source).pick(keys).omitBy(_.isNull).value());
}

export default mergeValues;
